<template>
  <div style="padding:20px;">
    <el-card>
      <h2>OPPO 子账户 API 密钥获取</h2>

      <el-form label-width="140px">
        <el-form-item label="Cookie">
          <el-input type="textarea" v-model="form.cookie" rows="3"/>
        </el-form-item>

        <el-form-item label="tk">
          <el-input v-model="form.tk"/>
        </el-form-item>

        <el-form-item label="子账户 OwnerId（一行一个）">
          <el-input type="textarea" v-model="form.ownerIds" rows="5" placeholder="一行一个 ownerId"/>
        </el-form-item>

        <el-button type="primary" @click="start" :loading="running">获取 API 信息</el-button>
      </el-form>
    </el-card>

    <el-card style="margin-top:20px;">
      <h3>执行日志</h3>
      <el-table :data="logs" border size="mini">
        <el-table-column prop="ownerId" label="OwnerId" width="140"/>
        <el-table-column prop="status" label="状态" width="100"/>
        <el-table-column prop="msg" label="信息"/>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  data () {
    return {
      running: false,
      logs: [],
      results: [],
      form: {
        cookie: '',
        tk: '',
        ownerIds: ''
      }
    }
  },
  methods: {

    log (ownerId, status, msg) {
      this.logs.push({ ownerId, status, msg })
    },

    post (url, data) {
      return this.$axios.post(url, data)
    },

    async start () {
      if (this.running) return
      this.running = true
      this.logs = []
      this.results = []

      const ids = this.form.ownerIds.split('\n').map(i => i.trim()).filter(i => i)

      for (let i = 0; i < ids.length; i++) {
        const ownerId = ids[i]
        try {
          this.log(ownerId, '处理中', '登录中...')

          await this.post('https://control.zjwec.cn/api/oppohook/ownerLoginForward', {
            cookie: this.form.cookie,
            tk: this.form.tk,
            ownerId: ownerId
          })

          this.log(ownerId, '处理中', '获取 API Key...')

          const res = await this.post('https://control.zjwec.cn/api/oppohook/getApiKey', {
            cookie: this.form.cookie,
            tk: this.form.tk,
            multiAccessId: ownerId
          })

          const d = res.data.data
          this.results.push({
            ownerName: d.ownerName,
            ownerId: ownerId,
            apiId: d.apiId,
            apiKey: d.apiKey
          })

          this.log(ownerId, '成功', '获取成功')

        } catch (e) {
          this.log(ownerId, '失败', e.message || '异常')
        }
      }

      this.running = false

      if (this.results.length > 0) {
        this.exportExcel()
      }
    },

    exportExcel () {
      const data = [
        ['账户名', 'OwnerId', 'ApiId', 'ApiKey'],
        ...this.results.map(r => [r.ownerName, r.ownerId, r.apiId, r.apiKey])
      ]

      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'API信息')

      const filename = 'oppo_api_keys_' + Date.now() + '.xlsx'
      XLSX.writeFile(wb, filename)

      this.$message.success('已导出：' + filename)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/oppo/getApi.vue